import { Grid, Typography } from '@mui/material';

// Our Components
import TextInput from 'components/Input/TextInput';
import CurrencyTextInput from 'components/Input/CurrencyTextInput';

// Our Constants
import { TEXT, NUMBER } from 'components/Input/Types';

function PriceALoanNewClientForm({
	clientFirstName,
	clientLastName,
	setClientFirstName,
	setClientLastName,
	clientAnnualIncome,
	setClientAnnualIncome,
	clientAssetsAmount,
	setClientAssetsAmount,
	clientCreditScore,
	setClientCreditScore
}) {
	return (
		<Grid
			component="form"
			container
			item
			noValidate
			columnSpacing={2}
			rowSpacing={3}
			autoComplete="off"
			sx={{ marginBottom: 4 }}
		>
			<Grid item xs={12}>
				<Typography variant="h2Gascogne">Client Information</Typography>
			</Grid>

			<Grid item xs={12} md={6}>
				<TextInput
					type={TEXT}
					label="Client First Name"
					value={clientFirstName}
					onChange={setClientFirstName}
					required
					error={clientFirstName?.length === 0}
					helperText="Please enter the client's first name"
				/>
			</Grid>

			<Grid item xs={12} md={6}>
				<TextInput
					type={TEXT}
					label="Client Last Name"
					value={clientLastName}
					onChange={setClientLastName}
					required
					error={clientLastName?.length === 0}
					helperText="Please enter the client's last name"
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<CurrencyTextInput
					value={clientAnnualIncome}
					onChange={setClientAnnualIncome}
					label="Client Annual Income"
					required
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<CurrencyTextInput
					value={clientAssetsAmount}
					onChange={setClientAssetsAmount}
					label="Client Assets Amount"
					required
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<TextInput
					type={NUMBER}
					label="Client Credit Score"
					value={clientCreditScore}
					onChange={setClientCreditScore}
					required
				/>
			</Grid>
		</Grid>
	);
}

export default PriceALoanNewClientForm;
